import { Show, createSignal, onMount } from 'solid-js';
import { Login } from '~shared/components/Login';
import { getAdminPassword } from '~shared/lib/api';
import { Setup } from './components/Setup';
import { Lookup } from './components/Lookup';
import { snapshotState } from './stores/snapshotStore';

export function App() {
  const [authed, setAuthed] = createSignal(false);
  onMount(() => setAuthed(!!getAdminPassword()));

  return (
    <div class="mx-auto flex max-w-5xl flex-col gap-4 px-5 pt-6 pb-20">
      <header class="flex flex-col gap-1">
        <h1 class="text-xl font-semibold">Boba Member Verify</h1>
        <p class="text-muted text-xs">
          Look up a person's BOBA team and FTLO clinic history in the Airtable
          FTLO base.
        </p>
      </header>

      <main class="flex flex-col gap-4">
        <Show
          when={authed()}
          fallback={<Login onAuthed={() => setAuthed(true)} />}
        >
          <Setup />
          <Show when={snapshotState.index}>
            <Lookup />
          </Show>
        </Show>
      </main>
    </div>
  );
}
